import { useState, useCallback } from 'react';
import type { UseGlossarioModalReturn } from '../types/glossario';

/**
 * Hook para controlar abertura/fechamento do modal de Glossário
 * 
 * @example
 * ```tsx
 * const { isOpen, abrir, fechar } = useGlossarioModal();
 * 
 * <Button onClick={() => abrir('WACC')}>Ver WACC</Button>
 * <GlossarioModal open={isOpen} onClose={fechar} />
 * ```
 */
export function useGlossarioModal(): UseGlossarioModalReturn {
  const [isOpen, setIsOpen] = useState(false);

  const abrir = useCallback((termoInicial?: string) => {
    setIsOpen(true);
    // TODO: Se termoInicial fornecido, atualizar busca no glossário
    if (termoInicial) {
      console.log('Abrir glossário com termo:', termoInicial);
    }
  }, []);

  const fechar = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    abrir,
    fechar,
  };
}
